import React, { useEffect, useRef, useState } from "react";
import DoctorOne from '../../assets/images/dashboard/profile-1.svg';
import { Image, UploadFile } from "../../components/componentIndex";
import { Button, CheckBox, CheckedImage, Input, Select } from "../../common/commonIndex";
import { useNavigate } from "react-router-dom";
import UploadIcon from '../../assets/images/upload-icon.svg';
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import CommonService from '../../services/API/commonService';
import SelfServiceFormService from '../../services/API/selfServiceForm'
import { toast } from "react-toastify";
import LogoIcon from '../../assets/images/logo/Logo.svg';

const SelfServiceForm = () => {
    const navigate = useNavigate();
    const [checkBoxList, setCheckBoxList] = useState(false);
    const [practiceInfo, setPracticeInfo] = useState({
        practiceName: '',
        streetAddress: '',
        city: '',
        state: '',
        zipCode: '',
        primaryContactName: '',
        email: '',
        mobileNumber: '',
        faxNumber: '',
        websiteURL: '',
        practiceNPINumber: '',
        termsAndConditionsAccepted: false,
    });
    const [isSubmit, setIsSubmit] = useState(false); // To track validation errors
    const [stateId, setStateId] = useState(1);
    const [cities, setCities] = useState({});
    const [zipCodeList, setZipCodeList] = useState({});
    const [states, setStates] = useState([]);
    const { state: data, dispatch } = useAuthenticationContext();
    const [isFetching, setIsFetching] = useState(false);
    const [errors, setErrors] = useState({}); // To track validation errors
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState({});

    useEffect(() => {
        getDemographicsState();
    }, [])

    const getDemographicsState = async () => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await CommonService.getDemographicsState(accessToken);
            if (response?.statusCode === 200) {
                setStates(response?.result);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsFetching(false);
        }
    }
    const getCities = async (stateId) => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await CommonService.getCities(stateId, accessToken);
            if (response?.statusCode === 200) {
                setCities(response?.result);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsFetching(false);
        }
    }
    const getStateZipCodes = async (cityId) => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await CommonService.getStateZipCodes(cityId, accessToken);
            if (response?.statusCode === 200) {
                setZipCodeList(response?.result);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsFetching(false);
        }
    }

    // Validation function for individual fields
    const validateField = (name, value) => {
        let error = '';
        switch (name) {
            case 'practiceName':
                if (!value) error = 'Practice name is required';
                break;
            case 'streetAddress':
                if (!value) error = 'Street address is required';
                break;

            case 'email':
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!value) error = 'Email is required';
                else if (!emailPattern.test(value)) error = 'Invalid email format';
                break;
            case 'mobileNumber':
                const phonePattern = /^\d{10}$/;
                if (!value) error = 'Phone number is required';
                else if (!phonePattern.test(value)) error = 'Invalid phone number';
                break;
            case 'state':
                if (!value) error = 'State is required';
                break;
            case 'city':
                if (!value) error = 'City is required';
                break;
            case 'zipCode':
                if (!value) error = 'Zip code is required';
                break;
            case 'practiceNPINumber':
                    // if (!/^\d{10}$/.test(value)) 
                    // return 'NPI must be exactly 10 digits';
                  
                if (!value) error = 'Practice NPI number is required';
                if (!/^\d{10}$/.test(value)) error = 'NPI should be exactly 10 digits';
                break;
            case 'primaryContactName':
                if (!value) error = 'Primary contact name is required';
                break;
            case 'termsAndConditionsAccepted':
                if (!value) error = 'You must accept the terms and conditions';
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (fieldName) => (event) => {
        setPracticeInfo({ ...practiceInfo, [fieldName]: event });

        const error = validateField(fieldName, event);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
    };

    const handleFileChange = (event) => {
        const file = event; //.target.files[0];
        setPracticeInfo({ ...practiceInfo, medicalRecords: file });

    };
    /* Callback function to handle radio button change */
    const handleRadioChange = (fieldName) => (value) => {
        setPracticeInfo({ ...practiceInfo, [fieldName]: value });
        const error = validateField(fieldName, value);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
    };

    const handleGenderChange = (fieldName, event) => {
        setPracticeInfo({ ...practiceInfo, [fieldName]: event });

        const error = validateField(fieldName, event);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));

        if (fieldName === 'city') {
            getStateZipCodes(event);
        }
        if (fieldName === 'state') {
            const findStateId = states.find(x => x.name?.toLowerCase() === event?.toLowerCase())?.id;
            setStateId(findStateId);
            getCities(findStateId);
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmit(true);
        const formErrors = {};
        Object.keys(practiceInfo).forEach((fieldName) => {
            const error = validateField(fieldName, practiceInfo[fieldName]);
            formErrors[fieldName] = error;
        });

        setErrors(formErrors);
        // Check if there are no errors
        const hasErrors = Object.values(formErrors).some((error) => error !== "");
        if (!hasErrors) {
            // navigate("/practice-registration-under-review");
            addUpdateSurgeryCenterSelfService(practiceInfo);
        }
        // Handle form submission here, e.g., send data to a server
    };

    const addUpdateSurgeryCenterSelfService = async (data) => {
        try {
            const stateId = states?.find(x => x.name === data?.state)?.id;
            const cityName = cities?.find(x => x.id === parseInt(data?.city))?.name;
            const zipCode = zipCodeList?.find(x => x.id === parseInt(data?.zipCode))?.zip;

            setIsLoading(true);
            // const formDataRequest = {
            //     "surgeryCenterName": data?.practiceName ?? '',
            //     "address": data?.streetAddress ?? '',
            //     "city": "",
            //     "state": "",
            //     "zipCode": "",
            //     "primaryContact": data?.primaryContactName ?? '',
            //     "emailAddress": data?.email ?? '',
            //     "phoneNumber": data?.mobileNumber ?? '',
            //     "faxNumber": data?.faxNumber ?? '',
            //     "fkStateId": stateId ?? '',
            //     "fkCityId": data?.city ?? '',
            //     "fkZipCodeId": data?.zipCode ?? '',
            //     "websiteUrl": data?.websiteURL ?? '',
            //     "npiNumber": data?.practiceNPINumber ?? '',
            //     "coverImage": "",
            //     "attachment": data?.medicalRecords ?? "",
            //     "rowStatus": 0,
            //   }
            const formDataRequest = new FormData();
            formDataRequest.append('surgeryCenterName', data?.practiceName);
            formDataRequest.append('address', data?.streetAddress);
            formDataRequest.append('city', cityName);
            formDataRequest.append('state', data.state);
            formDataRequest.append('zipCode', zipCode);
            formDataRequest.append('fkCityId', data?.city ?? '');
            formDataRequest.append('fkStateId', stateId ?? '');
            formDataRequest.append('fkZipCodeId', data?.zipCode ?? '');
            formDataRequest.append('primaryContact', data?.primaryContactName ?? '');
            formDataRequest.append('emailAddress', data?.email ?? '');
            formDataRequest.append('phoneNumber', data?.mobileNumber ?? '');
            formDataRequest.append('faxNumber', data?.faxNumber ?? '');
            formDataRequest.append('websiteUrl', data?.websiteURL ?? '');
            formDataRequest.append('coverImage', DoctorOne);
            formDataRequest.append('npiNumber', data?.practiceNPINumber ?? '');
            formDataRequest.append('attachment', data?.medicalRecords ?? '');
            const response = await SelfServiceFormService.addUpdateSurgeryCenterSelfService(formDataRequest);
            if (response?.statusCode === 200) {
                toast.success(response.message);
                navigate("/practice-registration-under-review");
            }

        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsLoading(false);
        }
    }
    const handleLandingPage = () => {
        navigate('/landing');
    };

    return (
        <>
            <div className='login-header-logo' onClick={handleLandingPage}>
                <Image imgUrl={LogoIcon} altText={'logo'} className={'logo'} />
            </div>
            <hr />
            <div className="custom-container self-serive-form-custom-content self-serive-form">
                {isLoading && (
                    <div className="loader-content">
                        <div className="loader"></div>
                    </div>
                )}
                <div className="referral-form">
                    <h4 className="page-title">Add your practice</h4>
                    <div className="row self-serive-form-content">
                        <div className="col-md-7">
                            <form className="insurance-card form-input-label">
                                <div>
                                    <h5 className="referrals-title mb-3">Practice information</h5>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <div className={`input-group form-item ${practiceInfo.practiceName?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'practiceName'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('practiceName')}
                                                    value={practiceInfo.practiceName} />
                                                <label htmlFor="firstName" className={practiceInfo.practiceName?.trim() !== '' ? 'is-active active' : 'active'} >Practice name</label>
                                                {practiceInfo.practiceName?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.practiceName && isSubmit ? errors.practiceName : ''}</p>
                                        </div>
                                        <div className="col-md-12">
                                            <div className={`input-group ${practiceInfo.streetAddress?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'streetAddress'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('streetAddress')}
                                                    value={practiceInfo.streetAddress} />
                                                <label htmlFor="streetAddress" className={practiceInfo.streetAddress?.trim() !== '' ? 'is-active active' : 'active'}>Street address</label>
                                                {practiceInfo.streetAddress?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.streetAddress && isSubmit ? errors.streetAddress : ''}</p>
                                        </div>

                                        <div className="col-md-6">
                                            <div className={`selection-content ${practiceInfo.state !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'state'}
                                                    defaultValue={0}
                                                    list={states || []}
                                                    value={practiceInfo?.state || null}
                                                    className={'bg-transparent'}
                                                    valueKey="name"
                                                    nameKey="name"
                                                    isProfile={true}
                                                    onChange={(value) => handleGenderChange('state', value)}
                                                />
                                                <label htmlFor="state" className={practiceInfo.state ? 'is-active active' : 'd-none active'}>Select state</label>
                                                {practiceInfo.state !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.state && isSubmit ? errors.state : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`selection-content ${practiceInfo.city !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'city'}
                                                    defaultValue={0}
                                                    list={cities || []}
                                                    value={practiceInfo?.city || null}
                                                    className={'bg-transparent'}
                                                    valueKey="id"
                                                    nameKey="name"
                                                    isProfile={true}
                                                    onChange={(value) => handleGenderChange('city', value)}
                                                />
                                                <label htmlFor="city" className={practiceInfo.city ? 'is-active active' : 'd-none active'}>Select city</label>
                                                {practiceInfo.city !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.city && isSubmit ? errors.city : ''}</p>
                                        </div>

                                        <div className="col-md-6">
                                            <div className={`selection-content ${practiceInfo.zipCode !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'zip code'}
                                                    defaultValue={0}
                                                    list={zipCodeList || []}
                                                    value={practiceInfo?.zipCode}
                                                    className={'bg-transparent'}
                                                    valueKey="id"
                                                    nameKey="zip"
                                                    isProfile={true}
                                                    onChange={(value) => handleGenderChange('zipCode', value)}
                                                />
                                                <label htmlFor="state" className={practiceInfo.zipCode !== '' && practiceInfo.zipCode !== 0 ? 'is-active active' : 'd-none active'}>Select zip code</label>
                                                {practiceInfo.zipCode !== 0 && practiceInfo.zipCode !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.zipCode && isSubmit ? errors.zipCode : ''}</p>
                                        </div>
                                        <div className="col-md-12">
                                            <div className={`input-group form-item ${practiceInfo.primaryContactName?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'primaryContactName'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('primaryContactName')}
                                                    value={practiceInfo.primaryContactName} />
                                                <label htmlFor="primaryContactName" className={practiceInfo.primaryContactName?.trim() !== '' ? 'is-active active' : 'active'} >Primary contact name</label>
                                                {practiceInfo.primaryContactName?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.primaryContactName && isSubmit ? errors.primaryContactName : ''}</p>
                                        </div>

                                        <div className="col-12">
                                            <div className={`input-group ${practiceInfo.email?.trim() !== '' || errors?.email ? 'valid' : ''}`}>
                                                <Input inputType={'email'} id={'email'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('email')}
                                                    value={practiceInfo.email} />
                                                <label htmlFor="email" className={practiceInfo.email ? 'is-active active email' : 'active'}>Practic email</label>
                                                {practiceInfo.email?.trim() !== '' && !errors?.email && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.email && isSubmit ? errors.email : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`input-group ${practiceInfo?.mobileNumber?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'mobileNumber'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('mobileNumber')}
                                                    value={practiceInfo.mobileNumber} isPhoneNumber={true} />
                                                <label htmlFor="mobileNumber" className={practiceInfo.mobileNumber?.trim() !== '' ? 'is-active active' : 'active'}>Phone number</label>
                                                {practiceInfo?.mobileNumber?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.mobileNumber && isSubmit ? errors.mobileNumber : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`input-group ${practiceInfo?.faxNumber?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'faxNumber'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('faxNumber')}
                                                    value={practiceInfo.faxNumber} isPhoneNumber={false} />
                                                <label htmlFor="faxNumber" className={practiceInfo.faxNumber?.trim() !== '' ? 'is-active active' : 'active'}>Fax number (optional)</label>
                                                {practiceInfo?.faxNumber?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.faxNumber && isSubmit ? errors.faxNumber : ''}</p>
                                        </div>
                                        <div className="col-md-12">
                                            <div className={`input-group ${practiceInfo?.websiteURL?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'websiteURL'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('websiteURL')}
                                                    value={practiceInfo.websiteURL} isPhoneNumber={false} />
                                                <label htmlFor="websiteURL" className={practiceInfo.websiteURL?.trim() !== '' ? 'is-active active' : 'active'}>Website URL (optional)</label>
                                                {practiceInfo?.websiteURL?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.websiteURL && isSubmit ? errors.websiteURL : ''}</p>
                                        </div>

                                        <div className="divider mb-3 mx-2"></div>

                                        <h5 className="practice-verification-title mb-3">Practice verification</h5>

                                        <div className="col-12">
                                            <div className={`input-group ${practiceInfo.practiceNPINumber?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'practiceNPINumber'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('practiceNPINumber')}
                                                    value={practiceInfo.practiceNPINumber} />
                                                <label htmlFor="practiceNPINumber" className={practiceInfo.practiceNPINumber?.trim() !== '' ? 'is-active active' : 'active'}>Practice NPI number</label>
                                                {practiceInfo.practiceNPINumber?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.practiceNPINumber && isSubmit ? errors.practiceNPINumber : ''}</p>
                                        </div>


                                        <p className="attach-document-title">
                                            To ensure only verified gastroenterology practices join GutChek, please upload <strong>ONE</strong> of the following:
                                        </p>

                                        <div>
                                            <ul>
                                                <li className="text-start attach-document-title">Malpractice insurance certificate</li>
                                                <li className="text-start attach-document-title">Billing statement from a GI supplier (Medtronic, Olympus, etc.)</li>
                                                <li className="text-start attach-document-title">EHR screenshot showing practice specialty</li>
                                            </ul>
                                        </div>
                                        {/* document-uploads */}
                                        <div className="mt-3 referral-upload">
                                            {/* <UploadDocument handleUploadFileChange={handleFileChange} value={patientInfo.medicalRecords} name={'Upload'} setValue={setPatientInfo}
                                            imgIcon={UploadIcon}
                                            buttonName={'Upload'}
                                            btnClass={'btn-upload'}
                                            btnType={'button'}
                                        /> */}
                                            <UploadFile handleUploadFileChange={handleFileChange} imgIcon={UploadIcon} id={'upload-file-1'}
                                                buttonName={'Upload'}
                                                btnClass={'btn-upload'}
                                                setFile={setFile}
                                                file={file}
                                                btnType={'button'} />
                                        </div>
                                        <div className={`is-agree ${file?.name ? 'mt-5' : ''}`}>
                                            {/* <CheckBox
                                            checkBox="gender"
                                            name={'I agree to GutChek Terms and Conditions'}
                                            id={0}
                                            onCheckBoxChange={handleRadioChange}
                                            formData={['I agree to GutChek Terms and Conditions']}
                                            isAllergiesCheck={true}
                                            value={checkBoxList}
                                            setValue={setCheckBoxList}
                                        /> */}
                                            <CheckBox
                                                checkBox="gender"
                                                name={'I agree to GutChek Terms and Conditions'}
                                                id={0}
                                                onCheckBoxChange={handleRadioChange('termsAndConditionsAccepted')}
                                                formData={['I agree to GutChek Terms and Conditions']}
                                                isAllergiesCheck={true}
                                                isReferralForm={true}
                                                value={checkBoxList}
                                                setValue={setCheckBoxList}
                                            />
                                            <p className="is-error">{errors.termsAndConditionsAccepted && isSubmit ? errors.termsAndConditionsAccepted : ''}</p>
                                        </div>
                                        <div className="justify-content-start">
                                            <Button btnType={'submit'}
                                                btnClass={'btn-primary question-btn practice-btn'}
                                                btnName={'Submit & Request Approval'}
                                                isDisabled={true}
                                                onClick={handleSubmit}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-5">
                            <div className="practice-verification-and-approval referrals-form-description">
                                <h5 className="practice-approval-title mb-3">Practice Verification & Approval</h5>
                                <div>
                                    <ul>
                                        <li>
                                            To maintain high standards, we verify all practices to ensure they specialize in <strong>gastroenterology</strong> and meet our <strong>open-access criteria.</strong>
                                        </li>
                                        <li>After submission, our team will review your details within <strong>24-48 hours.</strong></li>
                                        <li>
                                            If approved, you’ll gain access to <strong>setup your practice profile and add doctors.</strong>
                                        </li>
                                        <li><strong>Payment is only required when adding doctors.</strong></li>
                                    </ul>
                                </div>
                                <p className="description"> If we need additional verification, we’ll contact you via email.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default SelfServiceForm;